import { Loader } from '@southfields-digital/mxmz-react-ui';

import styles from './DataConnectorPanel.module.scss';

export const LoadingSection = () => {
  return (
    <div className={styles.LoadingSection}>
      <Loader />
    </div>
  );
};
